import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';
import { Locale, getCtLocale } from '../utils/internationalization';

interface LocaleContextType {
  locale: string;
  ctLocale: string;
}

interface LocaleContextProviderProps {
  children: ReactNode;
  locale: string;
  ctLocale: string;
}

export const LocaleContext = createContext<LocaleContextType>({
  locale: Locale.DEFAULT_LOCALE,
  ctLocale: getCtLocale(Locale.DEFAULT_LOCALE),
});

export const useLocaleContext = () => useContext(LocaleContext);

export function LocaleContextProvider({ children, locale, ctLocale }: LocaleContextProviderProps) {
  const value = useMemo(
    () => ({
      locale,
      ctLocale,
    }),
    [ctLocale, locale],
  );

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}
